import { render, staticRenderFns } from "./relateSubform.vue?vue&type=template&id=11d2080a&scoped=true&lang=pug"
import script from "./relateSubform.vue?vue&type=script&lang=js"
export * from "./relateSubform.vue?vue&type=script&lang=js"
import style0 from "./relateSubform.vue?vue&type=style&index=0&id=11d2080a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d2080a",
  null
  
)

export default component.exports